<button
  [type]="!!isSubmit ? 'submit' : 'button'"
  [disabled]="!!isDisabled"
  class="btn"
  [ngClass]="{
    'btn-fill': type === buttonType.Fill,
    'btn-outline': type === buttonType.Outline,
    'btn-color-primary': color === buttonColor.Primary,
    'btn-color-danger': color === buttonColor.Danger,
    'btn-size-small': size === buttonSize.Small,
    'btn-size-medium': size === buttonSize.Medium,
    'btn-size-large': size === buttonSize.Large
  }"
>
  <ng-content></ng-content>
</button>
